import { Form } from "react-bootstrap";
import { useCurrency } from "../../utils/useCurrency";

// Fase 2e (proyección/factura/pago, 2026-10-05) — extraída de `VincularProyeccionFacturaModal`
// (origen="factura") para que el freno anti-duplicado de `AsignarRecibidaModal` (§5 del diseño)
// reuse exactamente la misma lista, en vez de copiarla (10.1). Mismo formato de renglón, mismos
// 2 grupos (del proveedor / sin proveedor asignado) en ambos lugares.
export const estadoActivoLabel = (estado) =>
  estado === "ejecutado_sin_factura" ? "Ejecutado sin factura" : "Planificado";

const ActivosCandidatosLista = ({ activos, seleccionados, onToggle, maxHeight = 260 }) => {
  const { formatAmount } = useCurrency();

  if (activos.length === 0) {
    return (
      <div style={{ color: "#999", textAlign: "center", padding: 20 }}>
        No hay activos planificados candidatos de este proveedor.
      </div>
    );
  }

  // `getActivosParaVincularFactura` ya filtra a "mismo proveedor O sin proveedor asignado" (nunca
  // otro proveedor), así que partir por `proveedor_id != null` basta.
  const activosDelProveedor = activos.filter((a) => a.proveedor_id != null);
  const activosSinProveedor = activos.filter((a) => a.proveedor_id == null);

  return (
    <div style={{ maxHeight, overflowY: "auto", marginBottom: 12 }}>
      {[
        { titulo: "Del proveedor de la factura", lista: activosDelProveedor },
        { titulo: "Sin proveedor asignado", lista: activosSinProveedor },
      ].map(
        ({ titulo, lista }) =>
          lista.length > 0 && (
            <div key={titulo} style={{ marginBottom: 10 }}>
              <div style={{ fontSize: "0.72rem", fontWeight: 600, color: "#6c757d", marginBottom: 4 }}>{titulo}</div>
              {lista.map((a) => (
                <Form.Check
                  key={a.id}
                  type="checkbox"
                  id={`activo-candidato-${a.id}`}
                  checked={seleccionados.has(a.id)}
                  onChange={() => onToggle(a.id)}
                  label={`${a.descripcion || `#${a.id}`} — ${a.edificioNombre || "sin edificio"} — ${formatAmount(a.costo_unitario, a.moneda || "CLP")} — ${estadoActivoLabel(a.estado)}`}
                />
              ))}
            </div>
          )
      )}
    </div>
  );
};

export default ActivosCandidatosLista;
